import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreModule } from '../core';
import { AnalyticsRoutingModule } from './analytics-routing.module';
import { EkubsAnalyticsComponent } from './ekubs.analytics.component';
import { EkubAnalyticsComponent } from './ekub.analytics.component';
import { SimulatorComponent } from './simulator.component';
import { FusionChartsModule } from 'angular-fusioncharts';
import * as FusionCharts from 'fusioncharts';
import * as Charts from 'fusioncharts/fusioncharts.charts';
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import { PreferencesComponent } from './preferences.component';

FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, FusionChartsModule,
    CoreModule, AnalyticsRoutingModule],
  declarations: [EkubsAnalyticsComponent, EkubAnalyticsComponent, SimulatorComponent, PreferencesComponent]
})
export class AnalyticsModule { }
